import { getData } from './script_data.js';
const flipperFlags = getData('flipper-flags');
const fontDiscoveryConfig = getData('font-discovery-config');

export async function getAutocompleteResults(query) {
  const fontDiscoverySearchEnabled = flipperFlags?.EnableFontDiscoverySearch;
  if (fontDiscoverySearchEnabled) {
    const result = await getHighlightAutocompleteResults(query);
    return result;
  } else {
    const result = await getLegacyAutocompleteResults(query);
    return result;
  }
}

export async function getLegacyAutocompleteResults(query) {
  try {
    const response = await fetch('/search/autocomplete?query=' + query);
    if (!response.ok) {
      console.log('Failed to fetch legacy autocomplete results', response.status, response.statusText);
      return Promise.resolve({ data: [] });
    }
    const data = await response.json();
    return Promise.resolve({ data: data.map(function (item) {
      return { name: item.name, slug: item.slug };
    })});
  } catch (error) {
    console.log('Failed to fetch legacy autocomplete results');
    return Promise.resolve({ data: [] });
  }
}

export async function getHighlightAutocompleteResults(query) {
  const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'x-api-key': fontDiscoveryConfig.apiKey
  };

  const options = {
    headers: headers,
    method: 'POST',
    body: JSON.stringify({query: query, page_size: 12})
  };

  try {
    const response = await fetch(fontDiscoveryConfig.autocompleteUrl, options);
    if (!response.ok) {
      console.log('Failed to fetch autocomplete results', response.status, response.statusText);
      return Promise.resolve({ data: [] });
    }

    const data = await response.json();
    return Promise.resolve({ data: data.results });
  } catch (error) {
    console.log('Failed to fetch autocomplete results');
    return Promise.resolve({ data:  [] });
  }
}

export function getItemHyperlink(resultItem) {
  return '/fonts/' + resultItem.slug;
}
